import axios from "axios";
import { StockHolders, StockHoldersHeaders } from "@/models/stock-holders";
import { List, ListQueryParams } from "@/models/table";

export const getStockHoldersList = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, universe_id, next_page_url } = params;

    const url = next_page_url || `/API/v2/id/${universe_id}/holders/list/owners?dgformat`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options };

    const res = await axios.get<List<StockHolders, StockHoldersHeaders>>(url, {
        params: {
            ...defaultParams,
        },
    });

    return res.data;
};

export const getStockTopHolders = async (stock: number, from: string) => {
    const res = await axios.get<{ multi: { [key: string]: [number, number][] } }>("/API/holders_ts/top5/", {
        params: {
            from,
            stock,
        },
    });

    return res.data.multi;
};

export const getStockHolder = async (stock: number, holder: number) => {
    const res = await axios.get<{ [key: string]: [number, number][] }>("/API/holders_ts/stock", {
        params: {
            stock,
            holder,
        },
    });

    return res.data;
};

export const getStockHoldersRegisteredUnder = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, data, universe_id, next_page_url } = params;

    const url = next_page_url || `/API/v2/id/${universe_id}/holders/list/registeredunder/${data.companyId}?&dgformat`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options };

    const res = await axios.get<List<StockHolders, StockHoldersHeaders>>(url, {
        params: {
            ...defaultParams,
        },
    });

    return res.data;
};
